export default "__VITE_ASSET__Cv5Gu8pX__"